<div class="flex flex-col flex-auto line-of-business-card">
  <div class="line-of-business-img-wrapper">
    <img src="{{ lineOfBusiness.imageRef }}"/>
    <img class="gradient" src="/assets/images/Gradient05 2.png"/>
  </div>

  <div class="flex flex-col basis-full p-24">
      <div class="flex items-center mat-headline-5 mb-10 name">
          {{ lineOfBusiness.displayName }}
      </div>
      <div class="overline-font fw-600 mb-16 tagline">
          {{ lineOfBusiness.tagline | uppercase }}
      </div>
      <div class="flex flex-col basis-full justify-between p-24">
        <div class="body2-font mb-20">
            {{ lineOfBusiness.shortDescription }}
        </div>
        <button class="read-more-btn accent"
                [routerLink]="['/', tenant, RouterSegments.CATALOGUE]"
                [queryParams]="{filter: [lineOfBusiness.name]}">Read more</button>
      </div>
  </div>
</div>
